import {
  Stack,
  TextField,
} from "@mui/material";
import { FC, useState, useEffect } from "react";
import { usePassRequire } from "./usePassRequire";
import { PassCheckBlock } from "./PassCheckBlock";
import { useWidth } from "../../modules/app/hooks/useWidth";

export const PasswordChange: FC<{
  askCurrentPassword: boolean;
  userEmail?: string;
  onCurrentPasswordChange?: (value: string) => void;
  onNewPasswordChange?: (value: string) => void;
  onConfirmPasswordChange?: (value: string) => void;
  onIsReadyChange?: (isReady: boolean) => void;
  onIsValidChange?: (isValid: boolean) => void;
  onIsSameChange?: (isSame: boolean) => void;
}> = ({
  askCurrentPassword,
  userEmail,
  onCurrentPasswordChange,
  onNewPasswordChange,
  onConfirmPasswordChange,
  onIsReadyChange,
  onIsValidChange,
  onIsSameChange,
}) => {
  const width = useWidth();
  const [currentPass, setCurrentPass] = useState("");
  const [newPass, setNewPass] = useState("");
  const [confirmPass, setConfirmPass] = useState("");
  const [confirmError, setConfirmError] = useState("");

  const {
    isMinLength,
    isHaveLower,
    isHaveUpper,
    isHaveNumber,
    isHaveSpecial,
    validPass,
    isSamePass,
    isNotEqual,
  } = usePassRequire(userEmail, newPass, confirmPass);

  useEffect(() => {
    onIsValidChange?.(validPass ?? false);
  }, [validPass, onIsValidChange]);

  useEffect(() => {
    onIsSameChange?.(isSamePass ?? false);
  }, [isSamePass, onIsSameChange]);

  useEffect(() => {
    onIsReadyChange?.((isSamePass ?? false) && (validPass ?? false));
  }, [isSamePass, validPass, onIsReadyChange]);

  const onChangePass = (
    value: string,
    cb: React.Dispatch<React.SetStateAction<string>>,
    onChangeCallback?: (value: string) => void
  ) => {
    setConfirmError("");
    cb(value);
    onChangeCallback?.(value);
  };

  return (
    <>
      <PassCheckBlock
        isMobile={["xs", "sm"].includes(width)}
        isNotEqual={isNotEqual}
        isHaveLower={isHaveLower}
        isHaveNumber={isHaveNumber}
        isHaveSpecial={isHaveSpecial}
        isHaveUpper={isHaveUpper}
        isMinLength={isMinLength}
      />
      <Stack
        direction={["xs", "sm"].includes(width) ? "column" : "row"}
        spacing={2}
      >
        {askCurrentPassword && (
          <TextField
            fullWidth
            value={currentPass.trim()}
            name='currentPass'
            label='Current password'
            type='password'
            inputProps={{
              onChange: (e) =>
                onChangePass(
                  (e.target as HTMLTextAreaElement).value,
                  setCurrentPass,
                  onCurrentPasswordChange
                ),
            }}
          />
        )}
        <TextField
          fullWidth
          value={newPass.trim()}
          name='newPass'
          label='New password'
          type='password'
          inputProps={{
            onChange: (e) =>
              onChangePass(
                (e.target as HTMLTextAreaElement).value,
                setNewPass,
                onNewPasswordChange
              ),
          }}
        />
        <TextField
          fullWidth
          value={confirmPass.trim()}
          name='confirmPass'
          label='Confirm password'
          type='password'
          error={!!confirmError}
          helperText={confirmError}
          inputProps={{
            onChange: (e) =>
              onChangePass(
                (e.target as HTMLTextAreaElement).value,
                setConfirmPass,
                onConfirmPasswordChange
              ),
            onBlur: () => {
              if (confirmPass.trim() && newPass.trim() && !isSamePass) {
                setConfirmError("The entered passwords must be the same");
              }
            },
          }}
        />
      </Stack>
    </>
  );
};
